module.exports = __webpack_public_path__ + "common/loading-130aaa1d3468e6ed13feb91f2f232982.gif";